import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/language-switcher/language-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/.pnpm/next-auth@5.0.0-beta.30_next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwr_f7659a4589c8ce050d325b3c48a6aa86/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+tes_ca9b3c9157d9edb9121b47f27cb698a7/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.4/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/overrides/@maestro.commerce-blocks/components/add-to-cart-button/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/banner/styles/banner.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/overrides/@maestro.commerce-blocks/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/navigation-footer/navigation-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/overrides/@maestro.commerce-blocks/components/product-card/product-card.tsx");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/recommendations/styles/recommendations.scss");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistProvider"] */ "/app/overrides/@maestro.commerce-blocks/providers/wishlist/wishlist.context.tsx");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.sanity/components/cms/styles/cms.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AlgoliaInsightsProvider"] */ "/app/packages/algolia-insights/providers/algolia-insights-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/address-shipping-switcher/address-shipping-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/article-teaser/article-teaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/banner/banner-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/banner/banner-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/cart/cart-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkErrorHandler"] */ "/app/packages/commerce-blocks/components/chunk-error-handler/chunk-error-handler.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/cms-image/styles/cms-image.scss");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.sanity-cms-blocks/blocks/cms-banners/styles/cms-banners.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/company-switcher/company-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/global-overlays/global-overlays-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/image-product/image-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/login/login-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/logo/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqStructuredData"] */ "/app/packages/commerce-blocks/components/metadata/faq-metadata.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/navigation-footer/navigation-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/notification/notification-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/app/packages/commerce-blocks/components/notification/notification.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/payments-list/payment-link-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-card/product-card-wishlist-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-labels/product-labels.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-simple-list/product-simple-list-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-simple-list/product-simple-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-slider/lazy-product-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-slider/product-slider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/product-variant-colors/styles/product-variant-colors.scss");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.sanity-cms-blocks/blocks/cms-tiles/styles/cms-tiles.scss");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/announcement-bar/styles/announcement-bar.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/font/local/target.css?{\"path\":\"styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/fonts/polar-icons/polar-icons-v1.0.woff2\",\"variable\":\"--global-icon__font-family\",\"display\":\"block\"}],\"variableName\":\"iconFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/font/local/target.css?{\"path\":\"styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../public/fonts/vipps/vippstext-bold-web.woff2\",\"weight\":\"700\"}],\"preload\":false,\"variable\":\"--global-vipps__font-family\"}],\"variableName\":\"vippsFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.4/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/reviews/stars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchProvider"] */ "/app/packages/commerce-blocks/components/search-bar/search.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/socials-list/social-link-item.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/socials-list/styles/socials-list.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/wishlist/wishlist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/app/packages/commerce-blocks/context/cart.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalContextProvider"] */ "/app/packages/commerce-blocks/context/global.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/loyalty/components/loyalty-terminate-membership-confirmation-modal/loyalty-terminate-membership-confirmation-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/loyalty/components/loyalty-voucher-list/loyalty-voucher-list.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/loyalty/components/loyalty-voucher-list/styles/loyalty-voucher-list.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryHeaderProvider"] */ "/app/packages/commerce-blocks/providers/category-header/category-header.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MaestroSessionProvider"] */ "/app/packages/commerce-blocks/providers/maestro-session/maestro-session.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavigationProvider"] */ "/app/packages/commerce-blocks/providers/mobile-navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListingReviewsProvider","useProductListingReviewsContext"] */ "/app/packages/commerce-blocks/providers/product-listing-reviews/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["calculateStrengthProgress"] */ "/app/packages/commerce-blocks/utils/password-strength.utils.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-consent-gate/cookiebot-consent-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiebotScriptAgentValidator"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-script/cookiebot-script-agent-validator.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-script/styles/cookiebot.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-trigger/cookiebot-trigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiebotEventPublisher"] */ "/app/packages/cookiebot-cookie-consent/providers/cookiebot-event-publisher.ts");
;
import(/* webpackMode: "eager", webpackExports: ["A11yProvider"] */ "/app/packages/core/a11y/a11y.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventPublish"] */ "/app/packages/core/event/components/event-publish.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventBusProvider"] */ "/app/packages/core/event/event-bus.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalyticsProvider"] */ "/app/packages/google-analytics/providers/google-analytics.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-accordion/styles/cms-accordion.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-article-teasers/styles/cms-article-teasers.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-ball-links/cms-ball-link-tracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-ball-links/styles/cms-ball-links.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-buttons/cms-button/cms-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-buttons/styles/cms-buttons.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-content-banner/styles/cms-content-banner.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-dy-recommendation/styles/cms-dy-recommendation.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-image-links-list/styles/cms-image-links-list.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-images/styles/cms-images.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-links/cms-link.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-member-advantages/styles/cms-member-advantages.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-products/styles/cms-products.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/data-table/styles/data-table.scss");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/tile/styles/tile.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity-cms-blocks/blocks/cms-video/styles/cms-video.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/cms-block/styles/cms-block.scss");
;
import(/* webpackMode: "eager" */ "/app/overrides/@maestro.commerce-blocks/components/footer/styles/footer.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/font/local/target.css?{\"path\":\"styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../public/fonts/polar-staff/polar-staff-regular.otf\",\"weight\":\"400\"},{\"path\":\"../public/fonts/polar-staff/polar-staff-medium.otf\",\"weight\":\"500\"},{\"path\":\"../public/fonts/polar-staff/polar-staff-bold.otf\",\"weight\":\"700\"}],\"preload\":false,\"variable\":\"--global-primary__font-family\"}],\"variableName\":\"primaryFont\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/commerce-blocks/components/usp/styles/usp.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity/components/cms/cms-page-preview.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity/components/preview-provider/preview-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/filter-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/label-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/swatch-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/embedded-script/embedded-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/embedded-video/embedded-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/icon/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/link/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreakpointProvider"] */ "/app/packages/ui/providers/breakpoint/breakpoint.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisabledPageScrollProvider"] */ "/app/packages/ui/providers/disabled-page-scroll/disabled-page-scroll.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ForesightProvider"] */ "/app/packages/ui/providers/foresight/foresight-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalsProvider"] */ "/app/packages/ui/providers/modals/modals.context.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/providers/password-strength/password-strength.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrefetchModeProvider","usePrefetchMode"] */ "/app/packages/ui/providers/prefetch-mode/prefetch-mode.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiProvider"] */ "/app/packages/ui/providers/ui/ui.tsx");
;
import(/* webpackMode: "eager" */ "/app/providers/project-settings/project-settings.context.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/main.scss");
